import { Component, OnInit } from '@angular/core';
import { UntypedFormControl as FormControl, UntypedFormGroup as FormGroup, Validators } from '@angular/forms';
import { AbstractWidgetComponent, AppServerAPI, ContextChange, TranslationService, WidgetStyle } from '@sdbn/common';

@Component({
    selector: 'app-visitor-statistic-export',
    templateUrl: './visitor-statistic-export.component.html',
    styleUrls: ['./visitor-statistic-export.component.scss'],
    standalone: false
})
export class VisitorStatisticExportComponent extends AbstractWidgetComponent implements OnInit {

  constructor(
    public translationService: TranslationService,
    private appServerAPI: AppServerAPI
  ) {
    super();
  }

  form: FormGroup;

  ngOnInit() {

    this.form = new FormGroup({
      dateFrom: new FormControl(new Date(), [Validators.required]),
      dateUntil: new FormControl(new Date(), [Validators.required]),
    });
  }

  onContextChange(contextChange: ContextChange) {
  }

  onSetElementAndContext() {
  }

  createExcel() {

    // Trigger opening a new tab. Must be as close as possible to a user action event.
    const newWindow = window.open('', 'listexcel-visitor-statistic');

    // keep focus in current window
    window.focus();

    const selection = new VisitSelection(this.form.value.dateFrom, this.form.value.dateUntil, 200);

    this.appServerAPI.execute<any>(`/client/visit/control/reporting/listexcel-visitor-statistic`, selection).subscribe(result => {

      const file = new Blob([result], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const fileURL = URL.createObjectURL(file);

      // we can open the file in a new tab
      if (newWindow !== null) {
        newWindow.location.href = fileURL;
      } else { // Fallback, if initial opener does not work. But popup blockers will block this.
        window.open(fileURL);
      }

    }, error => {
      console.error(error);
    });
  }

  public isUpdateListDisabled(): boolean {
    return this.form.value.dateFrom == null || this.form.value.dateUntil == null;
  }

  public isCreateDisabled(): boolean {
    return this.form.value.dateFrom == null || this.form.value.dateUntil == null;
  }

  getStyle(): WidgetStyle {
    return WidgetStyle.transparent;
  }

}

class VisitSelection {
  constructor(from: Date, until: Date, limit: number) {
    this.from = from;
    this.until = until;
    this.limit = limit;
  }
  from: Date;
  until: Date;
  limit: number;
}